import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { PedidoExpedicao } from '../../types/estoque';
import { pedidosExpedicaoService, clientesService } from '../../services';
import { makeOptionLoader } from '../../utils/optionLoaders';

const fields: ResourceField<PedidoExpedicao>[] = [
  { name: 'numero_pedido_cliente', label: 'Número do pedido', required: true },
  {
    name: 'entidade',
    label: 'Cliente/Entidade',
    type: 'async-select',
    valueType: 'number',
    loadOptions: makeOptionLoader(
      clientesService.list,
      (item: any) => item.nome_fantasia ?? item.razao_social ?? String(item.id),
    ),
  },
  {
    name: 'status',
    label: 'Status',
    type: 'select',
    options: [
      { label: 'Pendente', value: 'PENDENTE' },
      { label: 'Separando', value: 'SEPARANDO' },
      { label: 'Pronto', value: 'PRONTO' },
      { label: 'Expedido', value: 'EXPEDIDO' },
      { label: 'Cancelado', value: 'CANCELADO' },
    ],
  },
  { name: 'data_prevista_entrega', label: 'Data prevista de entrega', type: 'date' },
  { name: 'quantidade_total', label: 'Quantidade total', type: 'number' },
  { name: 'tipo_pallet', label: 'Tipo de produto' },
];

export const PedidosExpedicaoFormPage: React.FC = () => (
  <ResourceFormPage
    title="Novo pedido de expedição"
    description="Cadastre a solicitação do cliente."
    fields={fields}
    service={pedidosExpedicaoService}
    redirectPath="/admin/estoque/pedidos-expedicao"
    cancelPath="/admin/estoque/pedidos-expedicao"
  />
);
